import { EditNote } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent, LinearProgress } from '@mui/material';
import React, { useState } from 'react'
import documentDataServices from '../documentDataServices';
import { useAlert } from '../../../../context/AlertContext';

function DocumentNoteForm({documentId,onSuccess}) {
    const {AppAlert } = useAlert()
    const [note,setNote] = useState("");
    const [dialogStatus,setDialogStatus] = useState("");
    const [savingInProgress,setSavingStatus] = useState("");

    const handleClose = () =>{
        setNote("");
        setDialogStatus(false)
    }

    const onSubmit = () => {
        let payload = {
            documentId:documentId,
            note:note
        }
        setSavingStatus(true)
        documentDataServices.saveDocumentNote(payload).then(res=>{
            AppAlert(res.msg)
            onSuccess();
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setSavingStatus(false);
            handleClose();
        })
    }

    return (
        <>
            <div className='btn btn-primary me-2' onClick={()=>setDialogStatus(true)} ><EditNote/> Add A Note</div>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                <div className="form-floating mb-3 mt-3">
                    <textarea style={{height:100}} className="form-control" rows="5"  value={note} onChange={(e)=>setNote(e.target.value)}></textarea>
                    <label>Your Note Hare</label>
                </div>
                </DialogContent>
                <DialogActions>
                    <div className='row'>
                        <div className='col-md-12'>
                            {savingInProgress && <LinearProgress />}
                            {!savingInProgress &&
                                <>
                                    <button className='btn btn-outline-primary me-2' onClick={handleClose} >Cancel</button>
                                    <button className='btn btn-primary' onClick={onSubmit}>Save</button>
                                </>
                            }
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DocumentNoteForm